function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState, useContext } from 'react';
import PropTypes from 'prop-types';
import withCssProps from '../../hocs/withCssProps';
import { MenuSlide } from './MenuSlide';
import { AgroHeaderContext } from '../../contexts/AgroHeaderContext';
var MobileMenu = withCssProps(function (_ref) {
  var _ref$items = _ref.items,
    items = _ref$items === void 0 ? [] : _ref$items,
    _ref$isOpen = _ref.isOpen,
    isOpen = _ref$isOpen === void 0 ? false : _ref$isOpen,
    tagManager = _ref.tagManager;
  var _useContext = useContext(AgroHeaderContext),
    notifications = _useContext.notifications,
    user = _useContext.user;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    accountNotif = _useState2[0],
    setAccountNotif = _useState2[1];
  var _useState3 = useState([{
      Title: '',
      Children: items
    }]),
    _useState4 = _slicedToArray(_useState3, 2),
    menuSlides = _useState4[0],
    setMenuSlides = _useState4[1];
  var _next = function next(evt, item) {
    evt.preventDefault();
    item.ID === '255' ? setAccountNotif(notifications) : setAccountNotif(null);
    if (item.Children && item.Children.length > 0) {
      setMenuSlides([].concat(_toConsumableArray(menuSlides), [{
        Title: item.Name,
        LinkText: item.LinkText,
        URL: item.URL,
        Children: item.Children
      }]));
    } else {
      window.location = item.URL;
    }
  };
  var _back = function back() {
    var prevMenuSlides = _toConsumableArray(menuSlides);
    prevMenuSlides.pop();
    setMenuSlides(prevMenuSlides);
  };
  var filterLogged = function filterLogged(currentItems) {
    return user && user.isLogged ? currentItems.filter(function (item) {
      return item.WhenLogged === '1';
    }) : currentItems.filter(function (item) {
      return item.WhenNotLogged === '1';
    });
  };
  var current = _toConsumableArray(menuSlides).pop();
  return /*#__PURE__*/React.createElement(React.Fragment, null, isOpen ? /*#__PURE__*/React.createElement(MenuSlide, {
    title: current.Title,
    linkText: current.LinkText,
    URL: current.URL,
    items: filterLogged(current.Children),
    notifications: accountNotif,
    next: function next(evt, item) {
      return _next(evt, item);
    },
    back: function back() {
      return _back();
    },
    tagManager: tagManager
  }) : null);
});
MobileMenu.propTypes = {
  items: PropTypes.array,
  isOpen: PropTypes.bool
};
MobileMenu.displayName = 'MobileMenu';
export { MobileMenu };